import "./Home.css";
import { useNavigate } from "react-router-dom";
import logoImg from "../assets/images/logo.svg";

export default function Home() {
  const navigate = useNavigate(); // 👈 REQUIRED

  return (
    <div className="app">
      <div className="bg"></div>
  <img src={logoImg} alt="home" className="home-logo-image" />
      <div className="content">
        {/* <h1>
         Lorem Ipsum
        </h1> */}

        <p>
         Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
        </p>

        <button
          className="cta-btn"
          onClick={() => navigate("/login")}
        >
          <span className="lock">»</span>
          Get Started 
        </button>
      </div>
    </div>
  );
}
